import { useAuth } from '@/features/auth/authContext'

const INVITING_ROLES: ReadonlySet<string> = new Set(['branch_manager', 'company_admin'])

export function roleCanInvite(roleKey: string | undefined): boolean {
  return roleKey !== undefined && INVITING_ROLES.has(roleKey)
}

/**
 * Inviting is `USER_INVITE`, held by `branch_manager` and `company_admin`; everyone
 * else gets a 403 `CAPABILITY_REQUIRED`, so offering them the button only invites a
 * failure.
 *
 * This hides the action; it does not replace handling the 403. The server
 * decides, and a role can change under a tab that has been open for hours.
 */
export function useCanInviteUsers(): boolean {
  const { role } = useAuth()
  return roleCanInvite(role?.key)
}
